import { useState } from "react";
import styled from "styled-components";

interface YearBookingOptionsPopupContentsProps {
  currentRound?: any;
  bookingApplication?: any;
  hasSavedData?: boolean;
  activeAwardsIds?: number[];
  mealActiveIds?: number[];
  roomActiveIds?: number[];
  shopActiveIds?: number[];
  shopItemValue?: string;
  handleShopItemValueChange?: (e: any) => void;
  etcValue?: string;
  handleEtcValue?: (e: any) => void;
  closeopenOptionPopup?: () => void;
  handleSubmit?: (tempSave?: boolean) => void;
  isFixed?: boolean;
  onAwardsChange?: (awards: string[]) => void;
  onMealChange?: (meal: string) => void;
  onRoomChange?: (room: string) => void;
  onProshopChange?: (proshop: string) => void;
}

export default function YearBookingOptionsPopupContents(
  props: YearBookingOptionsPopupContentsProps
) {
  // 기존 데이터가 있으면 사용하고, 없으면 기본값 사용
  const [awards, setAwards] = useState<string[]>(
    props.activeAwardsIds
      ?.map((id) => {
        switch (id) {
          case 1:
            return "우승";
          case 2:
            return "준우승";
          case 3:
            return "3위";
          case 4:
            return "행운상";
          case 5:
            return "특별상";
          case 6:
            return "메달리스트";
          case 7:
            return "롱게스트";
          case 8:
            return "니어리스트";
          case 9:
            return "매너상";
          case 10:
            return "베스트드레서";
          default:
            return "";
        }
      })
      .filter(Boolean) || []
  );

  // 식사 옵션: 조식(1), 중식(2), 석식(3), 먹지않음(4)
  const getMealName = (id: number) => {
    switch (id) {
      case 1:
        return "조식";
      case 2:
        return "중식";
      case 3:
        return "석식";
      case 4:
        return "먹지않음";
      default:
        return "먹지않음";
    }
  };

  // 룸 이용 옵션: 라운드전(1), 라운드후(2), 이용하지 않아요(3)
  const getRoomName = (id: number) => {
    switch (id) {
      case 1:
        return "라운드전";
      case 2:
        return "라운드후";
      case 3:
        return "이용하지 않아요";
      default:
        return "이용하지 않아요";
    }
  };

  const [meal, setMeal] = useState<string>(
    props.mealActiveIds?.[0] ? getMealName(props.mealActiveIds[0]) : "먹지않음"
  );
  const [room, setRoom] = useState<string>(
    props.roomActiveIds?.[0] ? getRoomName(props.roomActiveIds[0]) : "이용하지 않아요"
  );
  const [proshop, setProshop] = useState<string>(props.shopActiveIds?.[0] === 1 ? "유" : "무");

  // 상태가 변경될 때마다 부모에게 전달 (무한 루프 방지를 위해 제거)
  // useEffect(() => {
  //   if (props.onAwardsChange) {
  //     props.onAwardsChange(awards);
  //   }
  // }, [awards, props.onAwardsChange]);

  // useEffect(() => {
  //   if (props.onMealChange) {
  //     props.onMealChange(meal);
  //   }
  // }, [meal, props.onMealChange]);

  // useEffect(() => {
  //   if (props.onRoomChange) {
  //     props.onRoomChange(room);
  //   }
  // }, [room, props.onRoomChange]);

  // useEffect(() => {
  //   if (props.onProshopChange) {
  //     props.onProshopChange(proshop);
  //   }
  // }, [proshop, props.onProshopChange]);

  const toggleSelection = (category: string, value: string) => {
    if (category === "awards") {
      const newAwards = awards.includes(value)
        ? awards.filter((item) => item !== value)
        : [...awards, value];
      setAwards(newAwards);
    }
  };

  return (
    <Container className="round-options-container">
      {/* Main Content */}
      <div className="content">
        <h2 className="main-title">라운드 옵션을 선택해주세요.</h2>

        {/* Awards Section */}
        <div className="section">
          <div className="section-title">
            <span className="required">*</span> 시상 요청
          </div>
          <div className="button-group">
            <button
              className={`option-button ${awards.includes("우승") ? "selected" : ""}`}
              onClick={() => !props.isFixed && toggleSelection("awards", "우승")}
              disabled={props.isFixed}
            >
              우승
            </button>
            <button
              className={`option-button ${awards.includes("준우승") ? "selected" : ""}`}
              onClick={() => !props.isFixed && toggleSelection("awards", "준우승")}
              disabled={props.isFixed}
            >
              준우승
            </button>
            <button
              className={`option-button ${awards.includes("3위") ? "selected" : ""}`}
              onClick={() => !props.isFixed && toggleSelection("awards", "3위")}
              disabled={props.isFixed}
            >
              3위
            </button>
            <button
              className={`option-button ${awards.includes("행운상") ? "selected" : ""}`}
              onClick={() => !props.isFixed && toggleSelection("awards", "행운상")}
              disabled={props.isFixed}
            >
              행운상
            </button>
            <button
              className={`option-button ${awards.includes("메달리스트") ? "selected" : ""}`}
              onClick={() => !props.isFixed && toggleSelection("awards", "메달리스트")}
              disabled={props.isFixed}
            >
              메달리스트
            </button>
            <button
              className={`option-button ${awards.includes("특별상") ? "selected" : ""}`}
              onClick={() => !props.isFixed && toggleSelection("awards", "특별상")}
              disabled={props.isFixed}
            >
              특별상
            </button>
            <button
              className={`option-button ${awards.includes("롱게스트") ? "selected" : ""}`}
              onClick={() => !props.isFixed && toggleSelection("awards", "롱게스트")}
              disabled={props.isFixed}
            >
              롱게스트
            </button>
            <button
              className={`option-button ${awards.includes("니어리스트") ? "selected" : ""}`}
              onClick={() => !props.isFixed && toggleSelection("awards", "니어리스트")}
              disabled={props.isFixed}
            >
              니어리스트
            </button>
            <button
              className={`option-button ${awards.includes("매너상") ? "selected" : ""}`}
              onClick={() => !props.isFixed && toggleSelection("awards", "매너상")}
              disabled={props.isFixed}
            >
              매너상
            </button>
            <button
              className={`option-button ${awards.includes("베스트드레서") ? "selected" : ""}`}
              onClick={() => !props.isFixed && toggleSelection("awards", "베스트드레서")}
              disabled={props.isFixed}
            >
              베스트드레서
            </button>
          </div>
        </div>

        {/* Meal Section */}
        <div className="section">
          <div className="section-title">
            <span className="required">*</span> 식사
          </div>
          <div className="button-group">
            <button
              className={`option-button ${meal === "조식" ? "selected" : ""}`}
              onClick={() => {
                if (!props.isFixed) {
                  setMeal("조식");
                }
              }}
              disabled={props.isFixed}
            >
              조식
            </button>
            <button
              className={`option-button ${meal === "중식" ? "selected" : ""}`}
              onClick={() => {
                if (!props.isFixed) {
                  setMeal("중식");
                }
              }}
              disabled={props.isFixed}
            >
              중식
            </button>
            <button
              className={`option-button ${meal === "석식" ? "selected" : ""}`}
              onClick={() => {
                if (!props.isFixed) {
                  setMeal("석식");
                }
              }}
              disabled={props.isFixed}
            >
              석식
            </button>
            <button
              className={`option-button ${meal === "먹지않음" ? "selected" : ""}`}
              onClick={() => {
                if (!props.isFixed) {
                  setMeal("먹지않음");
                }
              }}
              disabled={props.isFixed}
            >
              먹지않음
            </button>
          </div>
        </div>

        {/* Room Usage Section */}
        <div className="section">
          <div className="section-title">
            <span className="required">*</span> 룸 이용
          </div>
          <div className="button-group">
            <button
              className={`option-button ${room === "라운드전" ? "selected" : ""}`}
              onClick={() => {
                if (!props.isFixed) {
                  setRoom("라운드전");
                }
              }}
              disabled={props.isFixed}
            >
              라운드전
            </button>
            <button
              className={`option-button ${room === "라운드후" ? "selected" : ""}`}
              onClick={() => {
                if (!props.isFixed) {
                  setRoom("라운드후");
                }
              }}
              disabled={props.isFixed}
            >
              라운드후
            </button>
            <button
              className={`option-button ${room === "이용하지 않아요" ? "selected" : ""}`}
              onClick={() => {
                if (!props.isFixed) {
                  setRoom("이용하지 않아요");
                }
              }}
              disabled={props.isFixed}
            >
              이용하지 않아요
            </button>
          </div>
        </div>

        {/* Pro Shop Section */}
        <div className="section">
          <div className="section-title">
            <span className="required">*</span> 프로샵 이용
          </div>
          <div className="button-group">
            <button
              className={`option-button ${proshop === "유" ? "selected" : ""}`}
              onClick={() => {
                if (!props.isFixed) {
                  setProshop("유");
                }
              }}
              disabled={props.isFixed}
            >
              유
            </button>
            <button
              className={`option-button ${proshop === "무" ? "selected" : ""}`}
              onClick={() => {
                if (!props.isFixed) {
                  setProshop("무");
                }
              }}
              disabled={props.isFixed}
            >
              무
            </button>
          </div>
        </div>

        {/* Award Item Section */}
        {proshop === "유" && (
          <div className="section">
            <div className="section-title">
              <span className="required">*</span> 시상품
            </div>
            <input
              type="text"
              className="text-input"
              placeholder="상금: 1000000"
              defaultValue={props.shopItemValue || "상금: 1000000"}
              disabled={props.isFixed}
              onChange={props.handleShopItemValueChange}
            />
          </div>
        )}

        {/* Other Notes Section */}
        <div className="section">
          <div className="section-title">
            <span className="required">*</span> 기타사항
          </div>
          <textarea
            className="text-area"
            placeholder="기타사항을 입력하세요"
            rows={3}
            defaultValue={props.etcValue || ""}
            disabled={props.isFixed}
            onChange={props.handleEtcValue}
          />
        </div>

        {/* Action Buttons */}
        <div className="action-buttons">
          <button className="back-button-action" onClick={props.closeopenOptionPopup}>
            뒤로 가기
          </button>
          <button
            className="save-button"
            disabled={props.isFixed}
            onClick={() => {
              // 현재 선택된 옵션들을 부모에게 전달
              const currentOptions = {
                awards: awards,
                meal: meal,
                room: room,
                proshop: proshop,
              };
              console.log("Saving options:", currentOptions);

              // 부모에게 현재 옵션들을 전달
              props.onAwardsChange?.(awards);
              props.onMealChange?.(meal);
              props.onRoomChange?.(room);
              props.onProshopChange?.(proshop);

              props.handleSubmit?.(true);
            }}
          >
            임시저장
          </button>
        </div>
      </div>
    </Container>
  );
}

const Container = styled.div`
  --teeshot-white: #fdfdfd;
  --teeshot-black: #1a1a1a;
  --teeshot-g2: #d1d5d8;
  --teeshot-g3: #f0f0f4;
  --teeshot-active: #007bff;
  --teeshot-warning: #ffcc3d;
  --teeshot-negative: #ff4949;
  --teeshot-orange: #f97000;

  height: 921px;
  background: var(--teeshot-white);
  position: relative;
  margin: 0 auto;
  font-family: "Pretendard", -apple-system, Roboto, Helvetica, sans-serif;

  /* Top Navigation */
  .top-nav {
    display: flex;
    width: 100%;
    height: 56px;
    align-items: center;
    border-bottom: 0.5px solid var(--teeshot-g2);
    background: var(--teeshot-white);
  }

  .nav-content {
    display: flex;
    align-items: center;
    width: 100%;
    padding: 0 16px;
    position: relative;
  }

  .back-button {
    width: 48px;
    height: 48px;
    background: none;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .nav-title {
    color: var(--teeshot-black);
    text-align: center;
    font-size: 18px;
    font-weight: 700;
    line-height: 22px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    margin: 0;
  }

  /* Main Content */
  .content {
    padding: 32px 16px;
  }

  .main-title {
    color: var(--teeshot-black);
    font-size: 18px;
    font-weight: 700;
    line-height: 24px;
    margin: 0 0 20px 0;
  }

  /* Sections */
  .section {
    margin-bottom: 48px;
  }

  .section-title {
    color: var(--teeshot-black);
    font-size: 14px;
    font-weight: 600;
    line-height: 18px;
    margin-bottom: 12px;
  }

  .required {
    color: var(--teeshot-orange);
    font-weight: 700;
  }

  /* Button Groups */
  .button-group {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }

  .option-button {
    display: flex;
    height: 44px;
    padding: 13px 24px;
    justify-content: center;
    align-items: center;
    border-radius: 6px;
    background: var(--teeshot-g3);
    border: none;
    cursor: pointer;
    font-family: "Pretendard", -apple-system, Roboto, Helvetica, sans-serif;
    font-size: 14px;
    font-weight: 500;
    line-height: 18px;
    color: var(--teeshot-black);
    transition: all 0.2s ease;
  }

  .option-button:hover {
    background: #e8e8ec;
  }

  .option-button.selected {
    background: var(--teeshot-active);
    color: white;
  }

  .option-button:disabled {
    background: var(--teeshot-g2);
    color: #79818a;
    cursor: not-allowed;
  }

  .option-button:disabled:hover {
    background: var(--teeshot-g2);
  }

  .option-button:disabled.selected {
    background: var(--teeshot-active);
    color: white;
  }

  /* Tee Buttons */
  .tee-button {
    display: inline-flex;
    height: 44px;
    padding: 13px 14px;
    justify-content: center;
    align-items: center;
    gap: 6px;
    border-radius: 6px;
    background: var(--teeshot-g3);
    border: none;
    cursor: pointer;
    font-family: "Pretendard", -apple-system, Roboto, Helvetica, sans-serif;
    font-size: 14px;
    font-weight: 500;
    line-height: 18px;
    color: var(--teeshot-black);
    transition: all 0.2s ease;
    min-width: 84px;
  }

  .tee-button:hover {
    background: #e8e8ec;
  }

  .tee-button.selected {
    background: var(--teeshot-active);
    color: white;
  }

  .tee-button:disabled {
    background: var(--teeshot-g2);
    color: #79818a;
    cursor: not-allowed;
  }

  .tee-button:disabled:hover {
    background: var(--teeshot-g2);
  }

  .tee-button:disabled.selected {
    background: var(--teeshot-active);
    color: white;
  }

  .tee-color {
    width: 12px;
    height: 12px;
    border-radius: 50%;
  }

  .tee-color.blue {
    background: var(--teeshot-active);
  }

  .tee-color.white {
    background: var(--teeshot-white);
    border: 0.5px solid var(--teeshot-g2);
  }

  .tee-color.yellow {
    background: var(--teeshot-warning);
  }

  .tee-color.red {
    background: var(--teeshot-negative);
  }

  /* Responsive adjustments for button sizes */
  .button-group .option-button:nth-child(1) {
    min-width: 114px;
  }

  .button-group .option-button:nth-child(2) {
    min-width: 114px;
  }

  .button-group .option-button:nth-child(3) {
    min-width: 114px;
  }

  /* Specific adjustments for meal buttons */
  .section:nth-of-type(5) .option-button {
    min-width: 84px;
  }

  /* Specific adjustments for room usage buttons */
  .section:nth-of-type(6) .option-button:nth-child(3) {
    min-width: 114px;
    padding: 13px 12px;
  }

  /* Specific adjustments for pro shop buttons */
  .section:nth-of-type(7) .option-button:nth-child(2) {
    min-width: 114px;
    padding: 13px 12px;
  }

  .section:nth-of-type(7) .option-button:nth-child(3) {
    min-width: 114px;
    padding: 13px 24px;
  }

  /* Action Buttons */
  .action-buttons {
    display: flex;
    gap: 8px;
    margin-top: 32px;
  }

  .back-button-action {
    flex: 1;
    height: 60px;
    padding: 10px 14px;
    justify-content: center;
    align-items: center;
    border-radius: 10px;
    border: 1px solid #004b49;
    background: var(--teeshot-white);
    color: #004b49;
    text-align: center;
    font-family: "Pretendard", -apple-system, Roboto, Helvetica, sans-serif;
    font-size: 18px;
    font-weight: 700;
    line-height: 22px;
    cursor: pointer;
  }

  .save-button {
    flex: 1;
    height: 60px;
    padding: 0 14px;
    justify-content: center;
    align-items: center;
    border-radius: 10px;
    background: #004b49;
    color: var(--teeshot-white);
    text-align: center;
    font-family: "Pretendard", -apple-system, Roboto, Helvetica, sans-serif;
    font-size: 18px;
    font-weight: 700;
    line-height: 22px;
    border: none;
    cursor: pointer;
  }

  .save-button:disabled {
    background: var(--teeshot-g2);
    color: #79818a;
    cursor: not-allowed;
  }

  /* Text Input and Textarea */
  .text-input {
    width: 100%;
    height: 44px;
    padding: 13px 16px;
    border-radius: 6px;
    border: 1px solid var(--teeshot-g2);
    background: var(--teeshot-white);
    font-family: "Pretendard", -apple-system, Roboto, Helvetica, sans-serif;
    font-size: 14px;
    font-weight: 500;
    line-height: 18px;
    color: var(--teeshot-black);
    box-sizing: border-box;
  }

  .text-input:focus {
    outline: none;
    border-color: var(--teeshot-active);
  }

  .text-input:disabled {
    background: var(--teeshot-g3);
    color: #79818a;
    cursor: not-allowed;
  }

  .text-area {
    width: 100%;
    padding: 13px 16px;
    border-radius: 6px;
    border: 1px solid var(--teeshot-g2);
    background: var(--teeshot-white);
    font-family: "Pretendard", -apple-system, Roboto, Helvetica, sans-serif;
    font-size: 14px;
    font-weight: 500;
    line-height: 18px;
    color: var(--teeshot-black);
    box-sizing: border-box;
    resize: vertical;
    min-height: 88px;
  }

  .text-area:focus {
    outline: none;
    border-color: var(--teeshot-active);
  }

  .text-area:disabled {
    background: var(--teeshot-g3);
    color: #79818a;
    cursor: not-allowed;
  }
`;
